import { Reveal } from "@components/ui";

const additionalConditions = [
  "Returned payments and bank fees are charged at actual cost.",
  "Extraordinary services, emergency works, or non-routine interventions outside the standard scope are charged separately under Annex E – Special Works.",
  "All customers are deemed to have accepted these charges by virtue of receiving GASIS supply or services.",
  "Fees and tariffs may be revised annually or under extraordinary circumstances, in line with UAE regulations and LPG market adjustments.",
];

export function MinimumChargesSection() {
  return (
    <section className="w-full bg-[#f6f6f9] overflow-hidden py-8 md:py-12 lg:py-[80px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col gap-5 md:gap-6 lg:gap-8">
        <Reveal direction="up">
          <div className="flex flex-col items-center gap-3 md:gap-4 text-center">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#122d63]/8 text-[#122d63] text-[13px] md:text-[15px] font-semibold tracking-[-0.02em] uppercase font-albert-sans">
              Charges & Conditions
            </span>
            <h2 className="text-[24px] md:text-[40px] lg:text-[54px] tracking-[-0.04em] font-semibold text-[#122d63] font-albert-sans leading-[1.1]">
              Minimum Monthly Charge/Additional Fees and Conditions
            </h2>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          <Reveal direction="left">
            <div className="h-full rounded-[12px] md:rounded-[16px] bg-white border border-transparent hover:border-[#122d63]/10 hover:shadow-[0_8px_32px_rgba(18,45,99,0.08)] p-5 md:p-6 lg:p-8 flex flex-col gap-4 md:gap-5 transition-all duration-300">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-[10px] bg-[#122d63]/8 text-[#122d63] flex items-center justify-center shrink-0">
                  <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
                    <path
                      d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h3 className="text-[22px] md:text-[28px] lg:text-[36px] tracking-[-0.04em] font-semibold text-[#1c1c1c] font-albert-sans leading-[1.2]">
                  Minimum Monthly Charge (MMC)
                </h3>
              </div>
              <p className="text-[14px] md:text-base lg:text-[24px] tracking-[-0.04em] text-[#1e1f24] font-albert-sans leading-[1.5]">
                A Minimum Monthly Charge may apply to each connected unit
                regardless of consumption.
                <br />
                <br />
                The MMC ensures network readiness, safety, and administrative
                costs are covered — particularly for vacant or low-use units.
                <br />
                <br />
                MMC values may vary by property type and are agreed under the
                service agreement with the building owner or management.
              </p>
            </div>
          </Reveal>

          <Reveal direction="right">
            <div className="h-full rounded-[12px] md:rounded-[16px] bg-white border border-transparent hover:border-[#122d63]/10 hover:shadow-[0_8px_32px_rgba(18,45,99,0.08)] p-5 md:p-6 lg:p-8 flex flex-col gap-4 md:gap-5 transition-all duration-300">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-[10px] bg-[#f24d2b]/10 text-[#f24d2b] flex items-center justify-center shrink-0">
                  <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
                    <path
                      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14 2v6h6M16 13H8M16 17H8M10 9H8"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h3 className="text-[22px] md:text-[28px] lg:text-[36px] tracking-[-0.04em] font-semibold text-[#1c1c1c] font-albert-sans leading-[1.2]">
                  Additional Fees and Conditions
                </h3>
              </div>
              <div className="flex flex-col gap-3 md:gap-4">
                {additionalConditions.map((condition) => (
                  <div
                    key={condition}
                    className="flex items-start gap-3 p-2.5 md:p-3 rounded-[10px] hover:bg-[#f8f9fb] transition-colors duration-200"
                  >
                    <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-[#122d63]/8 flex items-center justify-center shrink-0 mt-0.5">
                      <svg viewBox="0 0 24 24" fill="none" className="w-3 h-3 md:w-3.5 md:h-3.5">
                        <path
                          d="M5 12l5 5L20 7"
                          stroke="#122d63"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <p className="text-[14px] md:text-base lg:text-[24px] tracking-[-0.04em] text-[#1e1f24] font-albert-sans">
                      {condition}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
